"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarketplaceTooltip = _interopRequireDefault(require("../MarketplaceTooltip/MarketplaceTooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable import/no-cycle */
var MarketplaceShortcodes = function MarketplaceShortcodesFunction(_ref) {
  var identifier = _ref.identifier,
      attributes = _ref.attributes,
      tooltip = _ref.tooltip;

  switch (identifier) {
    case 'MarkdownTooltip':
      return /*#__PURE__*/_react["default"].createElement(_MarketplaceTooltip["default"], {
        display: true,
        hideIcon: true,
        title: attributes.title,
        message: tooltip.message,
        styleFlag: "inline"
      });

    default:
      return null;
  }
};

MarketplaceShortcodes.propTypes = {
  identifier: _propTypes["default"].string.isRequired,
  attributes: _propTypes["default"].shape({}).isRequired,
  tooltip: _propTypes["default"].shape({})
};
MarketplaceShortcodes.defaultProps = {
  tooltip: undefined
};
var _default = MarketplaceShortcodes;
exports["default"] = _default;